/**
 * The UI2 icon vocabulary — the complete set of glyph names a schema author
 * may write into a uiSchema, and the only names a `ui2:` component may render.
 *
 * Every name resolves to the same lucide glyph on NM, DW and MW. See
 * `.claude/docs/ui2-architecture.md` (Icons) for how to add one.
 */
export const UI2IconNames = {
  CHEVRON_RIGHT: 'chevron-right',
  CHEVRON_LEFT: 'chevron-left',
  CHEVRON_DOWN: 'chevron-down',
  CHEVRON_UP: 'chevron-up',
  ARROW_RIGHT: 'arrow-right',
  ARROW_LEFT: 'arrow-left',
  EXTERNAL_LINK: 'external-link',

  X: 'x',
  CIRCLE_X: 'circle-x',
  CHECK: 'check',
  CIRCLE_CHECK: 'circle-check',
  PLUS: 'plus',
  PENCIL: 'pencil',
  TRASH: 'trash',
  DOWNLOAD: 'download',
  UPLOAD: 'upload',
  PRINTER: 'printer',
  SEARCH: 'search',
  FILTER: 'filter',
  REFRESH_CW: 'refresh-cw',
  ROTATE_CCW: 'rotate-ccw',
  ZOOM_IN: 'zoom-in',
  MAXIMIZE: 'maximize',
  SHARE: 'share',

  TRIANGLE_ALERT: 'triangle-alert',
  CIRCLE_ALERT: 'circle-alert',
  INFO: 'info',
  CLOUD_OFF: 'cloud-off',
  LOCK: 'lock',
  EYE: 'eye',
  EYE_OFF: 'eye-off',

  CALENDAR: 'calendar',
  CLOCK: 'clock',
  MAP_PIN: 'map-pin',
  LOCATE_FIXED: 'locate-fixed',

  CAMERA: 'camera',
  IMAGE: 'image',
  FILM: 'film',
  SCAN_BARCODE: 'scan-barcode',
  SCAN_QR_CODE: 'scan-qr-code',
  SCAN_TEXT: 'scan-text',
  QR_CODE: 'qr-code',

  FILE: 'file',
  FILE_TEXT: 'file-text',
  FILE_ARCHIVE: 'file-archive',
  TABLE: 'table',
  PAPERCLIP: 'paperclip',

  TRUCK: 'truck',
  PACKAGE: 'package',
  USER: 'user',
} as const

export type UI2IconName = (typeof UI2IconNames)[keyof typeof UI2IconNames]

export const UI2_ICON_NAMES: UI2IconName[] = Object.values(UI2IconNames)
